"use client";

import { useState } from "react";
import Comparison from "@/components/preview/comparison";
import DemoSwitch from "@/components/preview/demo-switch";

interface ThemePalette {
  bg: string;
  body: string;
  border: string;
  heading: string;
  page: string;
}

const LIGHT: ThemePalette = {
  bg: "#ffffff",
  body: "#6f6f6f",
  border: "#e4e4e4",
  heading: "#1b1b1b",
  page: "#fcfcfc",
};

const DARK: ThemePalette = {
  bg: "#1d1d1d",
  body: "#a3a3a3",
  border: "#333333",
  heading: "#ededed",
  page: "#131313",
};

function ThemedCard({
  mechanism,
  surface,
  text,
}: {
  mechanism: string;
  surface: ThemePalette;
  text: ThemePalette;
}) {
  return (
    <div className="flex w-full flex-col items-center gap-2.5">
      <div
        className="flex h-36 w-full items-center justify-center rounded-xl border border-gray-400 px-4"
        style={{ background: surface.page }}
      >
        <div
          className="flex w-full max-w-48 flex-col gap-0.5 rounded-xl border p-2"
          style={{ background: surface.bg, borderColor: surface.border }}
        >
          <span className="font-medium text-sm" style={{ color: text.heading }}>
            Account
          </span>
          <span className="text-sm" style={{ color: text.body }}>
            Signed in as Ada.
          </span>
        </div>
      </div>
      <span className="font-berkeley-mono text-gray-900 text-xs leading-none">
        {mechanism}
      </span>
    </div>
  );
}

export default function ColorsThemeMechanismDemo() {
  const [dark, setDark] = useState(true);
  const surface = dark ? DARK : LIGHT;

  return (
    <Comparison
      bad={
        <ThemedCard
          mechanism="surface: .dark · text: media query"
          surface={surface}
          text={LIGHT}
        />
      }
      footer={
        <DemoSwitch
          checked={dark}
          label="Dark theme"
          onCheckedChange={setDark}
        />
      }
      good={
        <ThemedCard
          mechanism="all tokens: .dark"
          surface={surface}
          text={surface}
        />
      }
      panelClassName="select-none p-4"
      stackBelow="sm"
    />
  );
}
